import { createRoot, createComputed, on, onCleanup } from "solid-js";
import { unwrap } from "solid-js/store";
import type { Owner } from "solid-js";

export type StateEventsStatus = "first-assign" | "reassign" | "cleared";
export type StateEventsProps<T> = { value: T; previous: T; numAssigned: number };
export type StateEventsFunc<T> = (event: StateEventsStatus, props: StateEventsProps<T>) => void;
export type StateEventsInstance<T> = ReturnType<typeof createEvents<T>>;

function eventOccured<T>(obj: StateEventsProps<T>, value: T, previous: T) {
  let event: StateEventsStatus = undefined;
  if (obj.numAssigned === 0) {
    if (value !== previous) {
      // console.log("this is first assign with func :: ");
      event = "first-assign";
    }
  } else if (value !== previous) {
    if (value == undefined) {
      event = "cleared";
    } else {
      event = "reassign";
    }
  }
  if (event) {
    obj.value = unwrap(value);
    obj.previous = unwrap(previous);
    obj.numAssigned++;
  }
  return event;
}
// events creators
export function createEvents<T>(state: Solid.Accessor<T>, owner?: Owner) {
  const obj: StateEventsProps<T> = {
    value: undefined,
    previous: undefined,
    numAssigned: 0,
  };
  let funcs: StateEventsFunc<T>[] = undefined;
  let id = 0;
  createRoot(() => {
    createComputed(
      on(state, (value, previous) => {
        if (!funcs || funcs.length < 0) return;
        const event = eventOccured(obj, value, previous);
        if (event) {
          funcs.forEach((func) => {
            func?.(event, obj);
          });
        }
      })
    );
    onCleanup(() => {
      (funcs = undefined), (id = 0);
    });
  }, owner);
  // if (owner == undefined) {
  // } else {
  //   runWithOwner(owner, () => {
  //     createComputed(
  //       on(state, (value, previous) => {
  //         if (!funcs || funcs.length < 0) return;
  //         const event = eventOccured(obj, value, previous);
  //         if (event) {
  //           funcs.forEach((func) => {
  //             func?.(event, obj);
  //           });
  //         }
  //       })
  //     );
  //     onCleanup(() => {
  //       (funcs = undefined), (id = 0);
  //     });
  //   });
  // }
  return (set_func: StateEventsFunc<T>) => {
    id++;
    (set_func as any).__event_id = id;
    if (!funcs) funcs = [];
    funcs.push(set_func);
    return {
      unsubscribe() {
        const event_id = (set_func as any).__event_id;
        const event_idx = funcs.indexOf(set_func);
        // console.log("unsubscribing from event ", event_id, " :: ", event_idx);
        if (event_idx < 0) {
          console.error(
            "create-events: fatal couldn't find reference to registered event ",
            event_id,
            " :: ",
            set_func
          );
          return;
        }
        funcs.splice(event_idx, 1);
        this.unsubscribe = () => {
          console.warn("create-events: this event has already unsubscribed ", set_func);
        };
      },
    };
  };
}
